/* navigation */
// general styles for desktop navigation

/*
 * @prop --component-navigation-element-background-color-hover: Background color of navigation element on hover
 * @prop --component-navigation-element-color: color of navigation element
 * @prop --component-navigation-element-color-active-text: color of active navigation element
*/

// resonsive behaviour
/* stylelint-disable declaration-no-important */
@import '~@union-investment/global-resources/src/styles/solid-design-system';

ui-cms-navigation-element {
  @include reset-ul();
  @include reset-li();

  font-size: $serviceNavigation-font-size;
  line-height: 26px;

  .cursor-default {
    &::part(base) {
      cursor: default;
    }
  }

  .main-menu-item {
    &.first-level {
      .no-js & {
        position: static;
      }

      &.static {
        position: static;
      }
    }

    font-size: $serviceNavigation-font-size;

    @include breakpoint($desktop) {
      display: inline-block;
    }

    @include breakpoint($largeMaxWidth) {
      &.overview-link a {
        strong {
          color: var(--component-navigation-element-color-active-text, var(--skin-color-accent, $ui-green));
        }
      }
    }
  }

  .mega-menu {
    left: 0;
    position: fixed;
    z-index: $z-index-nav-flyout;
    background-color: $sd-backgroundColor-white;
    box-shadow: 0 1px 3px 0 rgba($ui-grey-plus-4, 0.75);
    margin: 0;
    padding: $sd-spacing-6;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    gap: $sd-spacing-4;

    &--opened {
      display: grid;
    }

    &--closed {
      display: none;
    }

    &.multilines {
      li {
        border-bottom: 1px solid $sd-borderColor-neutral-400;
      }

      &.rows-2 > li {
        &:nth-of-type(5),
        &:nth-of-type(6),
        &:nth-of-type(7),
        &:nth-of-type(8) {
          border-bottom: none;
        }
      }

      &.rows-3 > li {
        &:nth-of-type(9),
        &:nth-of-type(10),
        &:nth-of-type(11),
        &:nth-of-type(12) {
          border-bottom: none;
        }
      }
    }

    li {
      display: block;
      text-align: left;
    }

    .hub-navigation {
      grid-column: span 4;
      margin-top: $sd-spacing-4;
      border-top: 1px solid $sd-borderColor-neutral-400;

      &__headline {
        display: block;
        margin: $sd-spacing-8 $sd-spacing-4 $sd-spacing-4;
      }

      ul {
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: auto;
        gap: $sd-spacing-4;
      }
    }
  }

  .not-selectable {
    padding: $sd-spacing-3 $sd-spacing-4;
  }
}
